import React from 'react'

import { ReactComponent as DashboardSVG } from 'assets/images/dashboard.svg'
import { ReactComponent as DescriptionSVG } from 'assets/images/description.svg'
import { ReactComponent as LocationCitySVG } from 'assets/images/location-city.svg'
import { ReactComponent as SettingsSVG } from 'assets/images/settings.svg'
import { ReactComponent as FolderSVG } from 'assets/images/folder.svg'

import {
  DASHBOARD_PAGE,
  CONTEST_LIST_PAGE,
  INSTITUTION_LIST_PAGE,
  SETTINGS_PAGE,
  PRECEDENTS_PAGE
} from 'navigation/paths'

export type Link = {
  to: string
  title: string
  icon?: React.FC
  exact?: boolean
  children?: Link[]
}

export const links: Link[] = [
  {
    to: DASHBOARD_PAGE,
    title: 'common:sidebar.dashboard',
    icon: DashboardSVG,
    exact: true
  },
  {
    to: CONTEST_LIST_PAGE,
    title: 'common:sidebar.contest.contest',
    icon: DescriptionSVG
  },
  {
    to: INSTITUTION_LIST_PAGE,
    title: 'common:sidebar.institution',
    icon: LocationCitySVG
  },
  {
    to: PRECEDENTS_PAGE,
    title: 'common:sidebar.precedent',
    icon: FolderSVG
  },
  {
    to: SETTINGS_PAGE,
    title: 'common:sidebar.settings',
    icon: SettingsSVG
  }
]
